import { render, staticRenderFns } from "./auctionManage.vue?vue&type=template&id=fa6a68fe&scoped=true&"
import script from "./auctionManage.vue?vue&type=script&lang=js&"
export * from "./auctionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6a68fe",
  null
  
)

export default component.exports